import { EnterAmountType } from '../EnterAmountPage/EnterAmountProvider';

export const SummaryParams = {
  TYPE: 'type',
  CARD_UID_FROM: 'cardUidFrom',
  CARD_UID_TO: 'cardUidTo',
  AMOUNT: 'amount',
  CURRENCY: 'currency',
  SENDER: 'sender',
  RECEIVER: 'receiver',
  CARD_FROM_NAME: 'cardFromName',
  INSTALLMENT_ID: 'id',
  ORGANIZATION_CODE: 'organizationCode',
  MERCHANT_ID: 'merchantId',
  REASON_DESCRIPTION: 'reasonDescription'
};

export default class SummaryParser {
  static parseURLParams(currentParams) {
    const type = currentParams.get(SummaryParams.TYPE) || EnterAmountType.P2P;

    switch (type?.toUpperCase()) {
      case EnterAmountType.P2P: {
        const sender = currentParams.get(SummaryParams.SENDER);
        const receiver = currentParams.get(SummaryParams.RECEIVER);
        const currency = currentParams.get(SummaryParams.CURRENCY);
        const amount = currentParams.get(SummaryParams.AMOUNT);

        return {
          cardUidFrom: sender,
          cardUidTo: receiver,
          currency: currency,
          amount: Number(amount),
          service: EnterAmountType.P2P,
        };
      }
      case EnterAmountType.MICROLOAN: {
        const installmentId = currentParams.get(SummaryParams.INSTALLMENT_ID);
        const amount = currentParams.get(SummaryParams.AMOUNT);
        const organizationCode = currentParams.get(
          SummaryParams.ORGANIZATION_CODE,
        );
        return {
          amount: amount,
          organizationCode: organizationCode,
          id: installmentId,
        };
      }
      case EnterAmountType.MICROLOAN_PAYMENT: {
        const amount = currentParams.get(SummaryParams.AMOUNT);
        const currency = currentParams.get(SummaryParams.CURRENCY);
        const organizationCode = currentParams.get(
          SummaryParams.ORGANIZATION_CODE,
        );
        return {
          amount: Number(amount),
          currency: currency,
          service: EnterAmountType.MICROLOAN_PAYMENT,
          organizationCode: organizationCode,
        };
      }
      case EnterAmountType.POS: {
        const amount = currentParams.get(SummaryParams.AMOUNT);
        const currency = currentParams.get(SummaryParams.CURRENCY);
        const merchantId = currentParams.get(SummaryParams.MERCHANT_ID);
        const organizationCode = currentParams.get(
          SummaryParams.ORGANIZATION_CODE,
        );
        return {
          amount: Number(amount),
          currency: currency,
          service: EnterAmountType.POS,
          merchantId: merchantId,
          organizationCode: organizationCode,
        };
      }
      case EnterAmountType.SEND_MONEY_TO_COMPANY: {
        const amount = currentParams.get(SummaryParams.AMOUNT);
        const currency = currentParams.get(SummaryParams.CURRENCY);
        const organizationCode = currentParams.get(
          SummaryParams.ORGANIZATION_CODE,
        );
        return {
          amount: Number(amount),
          currency: currency,
          service: EnterAmountType.SEND_MONEY_TO_COMPANY,
          organizationCode: organizationCode,
        };
      }
    }
  }

  static parseResponse(type, data) {
    return data;
  }
}
